export enum DEMO_SITEKEY {
  pass = '1x00000000000000000000AA',
  fail = '2x00000000000000000000AB',
  interactive = '3x00000000000000000000FF'
}

export const siteKey: string =
  process.env.ENVIRONMENT === 'production' ? process.env.APP_RECAPTCHA_KEY! : DEMO_SITEKEY.pass
